import React, { useRef, useState } from 'react';
import { FieldRadioButton, QualificationModal } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';
import css from '../EditListingDescriptionForm.css';
import { horseQualifications } from '../../../marketplace-custom-config';
import { getPrefilledValueFromHorseType } from '../../../components/EditListingWizard/Helpers';
import { usePrefilledValue } from '../../../components/EditListingWizard/hooks/usePrefilledValue';
import { EDIT_LISTING_TAB_QUALIFICATIONS } from '../../../components/EditListingWizard/config';
import { PrefilledValueTooltip } from '../../../components/EditListingWizard/Components/PrefilledValueTooltip/PrefilledValueTooltip';

const FieldLabel = ({ label, description, handleQualificationClick }) => {
    return (
        <>
            <p className={css.qualificationLabel}>
                <span>{label}</span>
            </p>
            <p>
                {description || (
                    <span
                        className={css.qualificationActionLink}
                        onClick={handleQualificationClick}
                    >
                        Qualifikationen anzeigen
                    </span>
                )}
            </p>
        </>
    );
};

const fieldName = 'requiredQualificationLevel';

const EditListingDescriptionPageSeven = ({ form, currentListing, values }) => {
    const containerRef = useRef();
    const [qualificationKey, setQualificationKey] = useState(null);

    const prefilledValue = getPrefilledValueFromHorseType({
        tab: EDIT_LISTING_TAB_QUALIFICATIONS,
        values,
    });

    const { showPrefilledValue } = usePrefilledValue({
        form,
        fieldName,
        prefilledValue,
    });

    return (
        <>
            <div>
                <h1 className={css.horseTypeTitle}>
                    <FormattedMessage id="EditListingDescriptionForm.requiredQualificationTitle" />
                </h1>
                <p className={css.horseTypeSubTitle}>
                    <FormattedMessage id="EditListingDescriptionForm.requiredQualificationSubTitle" />
                </p>

                <div className={css.marginWrapper} ref={containerRef}>
                    {[...Object.values(horseQualifications)].map(({ key, label, description }) => {
                        const isPrefilledValue = showPrefilledValue && key === prefilledValue;

                        return (
                            <FieldRadioButton
                                id={key}
                                name={fieldName}
                                className={css.qualificationRadionButton}
                                form={form}
                                value={key}
                                label={
                                    <FieldLabel
                                        label={label}
                                        description={
                                            key === 'keine' ? (
                                                <span>Ist mir nicht wichtig</span>
                                            ) : (
                                                description
                                            )
                                        }
                                        handleQualificationClick={() => setQualificationKey(key)}
                                    />
                                }
                            >
                                {isPrefilledValue && (
                                    <PrefilledValueTooltip parentContainerRef={containerRef} />
                                )}
                            </FieldRadioButton>
                        );
                    })}
                </div>
            </div>
            {qualificationKey && (
                <QualificationModal
                    isOpen
                    onClose={() => setQualificationKey(null)}
                    currentListing={currentListing}
                    initialQualification={qualificationKey}
                />
            )}
        </>
    );
};

export default EditListingDescriptionPageSeven;
